export default __webpack_public_path__ + "static/media/151-facade.8a344852.png";